import { render, staticRenderFns } from "./Wp_join_robot_list_mark_model.vue?vue&type=template&id=19e390a7&scoped=true&"
import script from "./Wp_join_robot_list_mark_model.vue?vue&type=script&lang=js&"
export * from "./Wp_join_robot_list_mark_model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e390a7",
  null
  
)

export default component.exports